import { type AuthUser } from "wasp/auth";
import { getB2bPartnersAdmin, useQuery } from "wasp/client/operations";
import useTranslation from "../../../client/hooks/useTranslation";
import Breadcrumb from "../../layout/Breadcrumb";
import DefaultLayout from "../../layout/DefaultLayout";
import GrantsTable from "./GrantsTable";
import PartnersCard from "./PartnersCard";

export default function AdminB2bPage({ user }: { user: AuthUser }) {
  const t = useTranslation();
  const { data: partners, refetch } = useQuery(getB2bPartnersAdmin);
  const partnerList = partners ?? [];

  return (
    <DefaultLayout user={user}>
      <Breadcrumb pageName={t.adminB2b.pageTitle} />
      <div className="flex flex-col gap-6">
        <PartnersCard partners={partnerList} onChanged={refetch} />
        <GrantsTable
          partners={partnerList.map((p) => ({ id: p.id, name: p.name }))}
          onChanged={refetch}
        />
      </div>
    </DefaultLayout>
  );
}
